import React from 'react'
import { CollectionRouteProps } from '../../collections'
import { useOptaWidgetStart } from '../../cricket-match-centre/useOptaWidgetStart'
import { useProduct } from '../../__product/useProduct'
import { ThemeMargins } from '../../__styling'
import {
    FixtureScoreboardSponsorLogo,
    FixturesScoreboardWidgetContainer,
    FixturesScoreboardWidgetLogo,
    FixturesScoreboardWidgetLogoBottom,
    FixturesScoreboardWidgetLogoTop,
    FixturesScoreboardWidgetWrapper,
} from './AflFixturesScoreboardWidget.styled'
import { ArrowIcon } from './assets/ArrowIcon'

const tabTouchLogo = require('./assets/TABtouch_transparent.png')
export interface AflFixturesScoreboardWidgetProps extends CollectionRouteProps {
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
}

export const AflFixturesScoreboardWidget = ({
    verticalGutters,
    verticalSpacing,
}: AflFixturesScoreboardWidgetProps) => {
    useOptaWidgetStart()
    const product = useProduct()

    return (
        <FixturesScoreboardWidgetWrapper
            verticalSpacing={verticalSpacing}
            verticalGutters={verticalGutters}
        >
            <FixturesScoreboardWidgetLogo>
                <FixturesScoreboardWidgetLogoTop>
                    AFL
                </FixturesScoreboardWidgetLogoTop>
                <FixturesScoreboardWidgetLogoBottom to={`/sport/afl/fixtures`}>
                    {product === 'sevennews' && 'All '}
                    Fixtures <ArrowIcon />
                </FixturesScoreboardWidgetLogoBottom>
                {product !== 'sevennews' && (
                    <FixtureScoreboardSponsorLogo
                        src={tabTouchLogo}
                        width={102}
                    />
                )}
            </FixturesScoreboardWidgetLogo>
            <FixturesScoreboardWidgetContainer>
                <opta-widget
                    widget="fixtures"
                    template="strip"
                    live="false"
                    competition="12038"
                    season="2023"
                    match_status="all"
                    start_on_current="true"
                    order_by="date_ascending"
                    show_date="true"
                    show_crests={product === 'sevennews'}
                    date_format="dddd D MMMM"
                    time_format="HH:mm"
                    competition_naming="full"
                    team_naming="full"
                    pre_match="true"
                    match_link="/sport/afl/match-centre"
                    show_live="false"
                    show_logo="false"
                    show_title="false"
                    sport="afl"
                ></opta-widget>
            </FixturesScoreboardWidgetContainer>
        </FixturesScoreboardWidgetWrapper>
    )
}
